import React from 'react'

export default function ContactLensBrandField({
  brandField,
  manufacturerValue
}) {
  const matchedOption = brandField?.options?.find(
    option => option.key === manufacturerValue
  )
  const options =
    matchedOption?.value?.map(option => ({
      label: option.label,
      value: option.value || ''
    })) || []
  return (
    <div>
      <label>Brand</label>
      <select className='form-control' >
        {options.map(option => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
